<div class="web-links-container issue-checklist-container" *ngIf="(showComponent || (store.count$ | async))">
  <div class="web-links-header">
    <strong>Список</strong>
    <nb-icon (click)="toggleAdd()" icon="plus-circle-outline"></nb-icon>
  </div>

  <div class="percent-bar">
    <div class="pbar">
      <nb-progress-bar [value]="(store.percent$ | async)" status="primary" size="tiny" [displayValue]="true"></nb-progress-bar>
    </div>
    <div class="pcount"><span class="count-stat">{{ (store.checked$ | async) }}/{{ (store.count$ | async) }}</span></div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div *ngIf="add">
      <div class="form-flex">
        <input #headerInput nbInput fullWidth formControlName="header" fieldSize="medium" placeholder="Что нужно сделать?"/>
      </div>
      <div style="margin-top: 10px">
        <button nbButton size="small" status="primary" [disabled]="!form.valid || !header">Создать</button>
        &nbsp;
        <button nbButton size="small" status="basic" type="button" (click)="add=!add">Отмена</button>
      </div>
    </div>

    <nb-list class="nb-list" *ngIf="(store.items$ | async) as items">
      <nb-list-item class="nb-list-item" *ngFor="let item of items">
        <div class="left-position" [style.align-items]="editCheckListItem?.id === item.id ? 'center' : ''">

          <div style="max-width:24px">
            <nb-checkbox [(checked)]="item.checked" (checkedChange)="toggle(item)"></nb-checkbox>
          </div>

          <ng-container *ngIf="editCheckListItem?.id !== item.id">
            <div class="checkbox" [ngClass]="{'checked': item.checked}" (click)="edit(item)">{{ item.header }}</div>
          </ng-container>

          <ng-container *ngIf="editCheckListItem?.id === item.id">
            <div class="checkbox">
              <input nbInput fullWidth type="text" fieldSize="small"
                     [formControl]="checkListItemControl"
                     (keyup.enter)="update()" (focusout)="update()" required>
            </div>
          </ng-container>
        </div>
        <div class="right-position">
          <button nbButton ghost type="button" size="tiny" (click)="delete(item)" *ngIf="editCheckListItem?.id !== item.id">
            <nb-icon icon="trash-outline"></nb-icon>
          </button>
          <button nbButton ghost type="button" size="tiny" (click)="cancel()" *ngIf="editCheckListItem?.id === item.id">
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </div>
      </nb-list-item>
    </nb-list>
  </form>
</div>
